/** MIME type for HTML5 drag data from gallery assets (canvas/chat drop). */
export const CANVAS_ASSET_DROP_TYPE = 'application/x-air-canvas-asset';

/** MIME type for HTML5 drag data when dragging boards (canvas/chat reject with toast). */
export const CANVAS_BOARD_DROP_TYPE = 'application/x-air-canvas-board';

/** MIME type for HTML5 drag data when dragging chat media thumbnails (images/videos) to canvas. */
export const CANVAS_CHAT_MEDIA_DROP_TYPE = 'application/x-air-canvas-chat-media';

/** MIME type for HTML5 drag data when dragging canvas nodes back to a board for import. */
export const CANVAS_NODE_EXPORT_DROP_TYPE = 'application/x-air-canvas-node-export';

/** MIME type for HTML5 drag data storing the normalized grab anchor (JSON: {x, y} as 0–1 fractions) when dragging board assets. */
export const CANVAS_ASSET_GRAB_OFFSET_TYPE = 'application/x-air-canvas-asset-grab-offset';

/** MIME type marking which app surface an asset drag originated from, so the canvas drop target can attribute the import source. */
export const CANVAS_ASSET_IMPORT_SOURCE_TYPE = 'application/x-air-canvas-asset-import-source';

/** Gap between image nodes when adding multiple to canvas (drag and insert). */
export const CANVAS_IMAGE_NODE_SPACING = 40;

/** Default canvas image size when dimensions are missing (aligns drag and insert). */
export const DEFAULT_CANVAS_IMAGE_WIDTH = 480;
export const DEFAULT_CANVAS_IMAGE_HEIGHT = 360;
